import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {RemarkTypeService} from '../../apiModule';
import {CriterionService, IndexEntityService} from '../../apiModule1';

export const criterionResolver: ResolveFn<any> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  service: CriterionService = inject(CriterionService)) => {
  return service.apiCriterionGet({}, 'body', false, {transferCache: false});
};
